module.exports = __webpack_public_path__ + "img/9.a8c93872.jpg";